__turbopack_context__.v({
  "btnWrapper": "page-module__kIwKeG__btnWrapper",
  "contentWrapper": "page-module__kIwKeG__contentWrapper",
  "fields": "page-module__kIwKeG__fields",
  "forgotPasswordLink": "page-module__kIwKeG__forgotPasswordLink",
  "form": "page-module__kIwKeG__form",
  "loginWrapper": "page-module__kIwKeG__loginWrapper",
  "nextBtn": "page-module__kIwKeG__nextBtn",
  "passwordIcon": "page-module__kIwKeG__passwordIcon",
  "registrationDisclaimer": "page-module__kIwKeG__registrationDisclaimer",
  "speedTest": "page-module__kIwKeG__speedTest",
});
